import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import moment from 'moment';
import { getUser, getUserProfile } from '../actions/userAction';
import { receivedBrandData, didRequestInitialData, initTelescopeData, receivedTelescopeData, setEndDate, setStartDate, setAvailableDates} from '../actions/dataAction';
import SheetsDataWrapper from "./export-google-sheet/SheetsDataWrapper.js"

const Background = styled.div`
  background: #fff;
  position: fixed;
  top:0;
  left:0;
  bottom:0;
  right:0;
`;

const styles = {
  headline: {
    fontSize: 24,
    paddingTop: 16,
    marginBottom: 12,
    fontWeight: 400,
  },
};

class DataExport extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  initBrand(brand) {
    const _this = this;
    let Telescope = window.Telescope;
    const ts = new Telescope({brand: brand});

    ts.sync().then(() => {
      ts.date = moment().format('YYYY-MM-DD');
      ts.on('data', data => {
        if (!data || !(Object.keys(data).length === 0 && data.constructor === Object)) {
          _this.props.receivedBrandData(brand, data);
        }
      });
    });
  }

  initAdditionalBrands(client) {
    let brands = this.props.user && this.props.user.userProfile && this.props.user.userProfile.brands;
    if (brands && brands.length) {
      brands.forEach((brand,i) => {
        if (brand !== client) {
          this.initBrand(brand);
        }
      });
    }
  }

  initTelescope(client) {
    let Telescope = window.Telescope;
    let startDate = new Date(new Date().getFullYear() - 1, 0, 1);

    if (Telescope && client) {
      const ts = new Telescope({brand: client});
      this.props.initTelescopeData(ts);

      ts.range.then(([start, end]) => {
        const firstAvailableDate = moment(start).toDate();
        const lastAvailableDate = moment(end).toDate();
        startDate = moment(lastAvailableDate).subtract(1, 'year')

        this.props.setStartDate(startDate);
        this.props.setEndDate(lastAvailableDate);
        this.props.setAvailableDates({start: firstAvailableDate, end: lastAvailableDate});
      });

      ts.on('data', data => {
        if (!data || !(Object.keys(data).length === 0 && data.constructor === Object)) {
          this.props.receivedTelescopeData(data);
        }
      });
      ts.sync().then(() => {
        ts.range.then(([start, end]) => {
          const firstAvailableDate = moment(start).toDate();
          const lastAvailableDate = moment(end).toDate();
          this.props.setStartDate(startDate);
          this.props.setEndDate(lastAvailableDate);
          this.props.setAvailableDates({start: firstAvailableDate, end: lastAvailableDate});
        });

        ts.on('data', data => {
          if (!data || !(Object.keys(data).length === 0 && data.constructor === Object)) {
            this.props.receivedTelescopeData(data);
          }
        });
      });
    }
  }

  componentWillReceiveProps(props) {
    if (!this.props.user.userProfileLoaded) {
      this.props.getUserProfile();
    }

    if (this.props.user.userProfileLoaded && !this.props.data.didRequestInitialData && !this.state.didRequestInitialData) {
      const client = props.user.userProfile && props.user.userProfile.client.toLowerCase();
      this.initTelescope(client);
      this.initAdditionalBrands(client);
      this.setState({didRequestInitialData: true});
      this.props.didRequestInitialData();
    }
  }

  render() {

      return (
          <Background>
            <div className="container-fullwidth">
                <div className="text-center vertical-center">
                  <div className="col-sm-4 center-block" style={{ marginTop: '0px' }}>
                    <h2 style={styles.headline}>Data export</h2>
                    <SheetsDataWrapper data={this.props.data}/>
                  </div>
              </div>
            </div>
        </Background>
      );
  }
}

function mapStateToProps(state, onwProps) {
    return {
        user: state.user,
        data: state.data
    };
}

export default connect(mapStateToProps, { receivedBrandData, getUser, getUserProfile, didRequestInitialData, initTelescopeData, receivedTelescopeData, setEndDate, setStartDate, setAvailableDates })(DataExport);



// WEBPACK FOOTER //
// ./src/components/Export.js